var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css, cx } from '@emotion/css';
import React from 'react';
const styleErrorDetail = css `
    white-space: pre-wrap;
    overflow-wrap: break-word;
    margin: 0;
    font-size: 14px;
    line-height: calc(20 / 14);
    margin-bottom: 10px;
`;
export const ErrorDetail = (_a) => {
    var { name, value, className } = _a, rest = __rest(_a, ["name", "value", "className"]);
    return (React.createElement("div", Object.assign({ className: cx(className, styleErrorDetail) }, rest),
        React.createElement("strong", null, `${name}:`),
        ` ${value}`));
};
ErrorDetail.displayName = 'ErrorDetail';
//# sourceMappingURL=ErrorDetail.js.map